import { useEffect, useState } from 'react';
import { useInit } from '../../../../Contexts/InitProvider';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ImageUploadingIcon, UploadIcon } from '../../../../utils/SVGIcon';
import cn from '../../../../utils/cn';
import { ApiUploadBgLogo, ApiUploadLogo } from '../BasicOperation';

function BackgroundImage({ initInfo }) {
    if (!initInfo?.adminBackground) {
        return (
            <div className="flex items-center justify-center h-full w-full">
                <h2 className="text-primary text-lg">Not Set</h2>
            </div>
        );
    }
    return (
        <img
            src={initInfo?.adminBackground}
            alt="adminBackground"
            className="size-full object-cover rounded-10"
        />
    );
}

// Uploading  Temp Loading
function UploadingTempLoading({ type, handleFileChange, isLoading }) {
    return (
        <label
            htmlFor={type !== 'Logo' ? 'bgAttachmentFile' : 'attachmentFile'}
            className={cn(
                'flex justify-center items-center gap-2 w-full h-full rounded-10 cursor-pointer relative',
                {
                    'pointer-events-none select-none text-gray-400': isLoading
                }
            )}
        >
            <div className="cursor-pointer">
                <div className="flex items-center gap-1">
                    <span>Upload {type}</span>
                    <UploadIcon className="w-5 h-5" />
                </div>
                <div className="text-center" hidden={type !== 'Logo'}>
                    <span className="text-left text-[10px]">Ratio: (128 x 40)</span>
                </div>
            </div>
            {isLoading && (
                <div className="size-22 text-start bg-transparent text-secondary rounded-md absolute z-50 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ">
                    <ImageUploadingIcon />
                </div>
            )}
            <input
                id={type !== 'Logo' ? 'bgAttachmentFile' : 'attachmentFile'}
                type="file"
                className="w-full h-12 border border-gray-300 rounded-md px-4 hidden"
                onChange={handleFileChange}
                accept=".jpg, .jpeg, .png"
                data-max-files="1"
            />
        </label>
    );
}

function UploadImage({ type = 'Logo' }) {
    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState('');

    const { setMessage } = useTemplate();
    const { initStateUpdated, initInfo } = useInit();

    // Handle File Change and Upload
    const handleFileChange = (e) => {
        // Data Destructuring
        const { files } = e.target;
        // Check total selected files error handling
        if (files.length === 0) return;

        // min file size will be 100bytes
        // if (files?.[0] && files[0].size <= 100000) {
        //     setMessage({ type: 'error', text: 'File size too small, minimum file size 100 bytes' });
        //     return;
        // }

        // max file size will be 500bytes
        if (files?.[0] && files[0].size >= 500000) {
            setMessage({ type: 'error', text: 'File size too large, maximum file size 500bytes' });
            return;
        }
        const temFile = new FormData();
        temFile.append('profileImage', files[0]);
        setIsUploading(true);

        if (type !== 'Logo') {
            ApiUploadBgLogo(temFile, setError)
                .then((data) => {
                    setIsUploading(false);

                    setMessage({ type: 'success', text: data.title });
                    initStateUpdated();
                })
                .catch((err) => {
                    setError(err.toString(0));
                    setMessage({ type: 'error', text: err?.toString(0) });
                    setIsUploading(false);
                });
        } else {
            ApiUploadLogo(temFile, setError)
                .then((data) => {
                    setIsUploading(false);

                    setMessage({ type: 'success', text: data.title });
                    initStateUpdated();
                })
                .catch((err) => {
                    setError(err.toString(0));
                    setMessage({ type: 'error', text: err?.toString(0) });
                    setIsUploading(false);
                });
        }
    };

    // 3 sec error message hide
    useEffect(() => {
        if (error) {
            setTimeout(() => {
                setError('');
            }, 5000);
        }
    }, [error]);

    return (
        <div className="h-28 flex items-center gap-3">
            <div className="w-1/3 h-full flex justify-center">
                {type !== 'Logo' ? (
                    <BackgroundImage initInfo={initInfo} />
                ) : (
                    <img
                        src={initInfo?.adminLogo}
                        alt="adminLogo"
                        className="w-[128px] h-auto object-contain"
                    />
                )}
            </div>
            <div className="w-2/3 h-full border border-dashed border-secondary bg-secondary-100 rounded-10">
                <button type="button" className="w-full h-full text-secondary text-base">
                    <UploadingTempLoading
                        type={type}
                        handleFileChange={handleFileChange}
                        isLoading={isUploading}
                    />
                </button>
            </div>
        </div>
    );
}

export default UploadImage;
